<script>
  /* global KB */

  import { config } from '../store.js';
  import FallbackImage from './fallback-image.svelte';
  import SocialLinks from './social-links.svelte';
  /** @type {{item?: any}} */
  let { item = {}, index = 0 } = $props();

  // no wide cards for media

  let origin = $derived($config.origin || window.location.origin);

  let imageUrl = $derived(origin + item.imageUrl);

  let primaryTag = $derived(
    item.facets?.aecContentType ? item.facets.aecContentType[0] : false
  );
</script>

<div
  class="grid-item"
  data-search-module-result-position={index}
  data-item-colspan="1"
>
  <!-- {@html renderTemplate({ item })} -->

  <div class="simple-card time-over-image">
    <a href={$config.origin + item.link} title={item.title}>
      <div class="card-image">
        {#if item.imageUrl}
          <picture>
            <img src={imageUrl} alt={item.imageAlt} />
          </picture>
        {:else}
          <FallbackImage />
        {/if}
      </div>

      <div class="card-content">
        <div class="card-meta">
          {#if primaryTag}
            <span class="badge badge-filled theme-tertiary">{primaryTag}</span>
          {/if}
        </div>

        <p class="card-heading">{item.title}</p>

        <p class="card-excerpt">
          {item.description}
        </p>
      </div>
    </a>
    <div class="share-overlay">
      <button
        class="share-button"
        popovertarget="card-share-popover__{item.id}"
        aria-label="Share"
        type="button"
      >
        <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"
          ><path
            d="M10.3123 2.34368C10.3122 1.79377 10.5055 1.26135 10.8583 0.839564C11.2112 0.417778 11.7011 0.133488 12.2423 0.0364317C12.7836 -0.0606243 13.3418 0.0357345 13.8192 0.308649C14.2966 0.581564 14.6628 1.01366 14.8538 1.52933C15.0448 2.045 15.0484 2.61141 14.864 3.12947C14.6796 3.64752 14.3188 4.08423 13.8449 4.36319C13.371 4.64214 12.8142 4.74559 12.2717 4.65541C11.7292 4.56524 11.2357 4.2872 10.8776 3.86993L4.57945 6.79493C4.72424 7.25378 4.72424 7.74608 4.57945 8.20493L10.8776 11.1299C11.2562 10.6896 11.7848 10.4055 12.3609 10.3327C12.937 10.2599 13.5196 10.4036 13.9959 10.7359C14.4721 11.0682 14.808 11.5654 14.9385 12.1313C15.069 12.6971 14.9848 13.2913 14.7022 13.7986C14.4196 14.3059 13.9587 14.6902 13.4089 14.8771C12.8591 15.0639 12.2595 15.04 11.7263 14.81C11.1931 14.58 10.7643 14.1602 10.5229 13.632C10.2816 13.1038 10.2449 12.5048 10.4201 11.9512L4.12195 9.02618C3.81017 9.38953 3.39459 9.64867 2.93112 9.76876C2.46764 9.88885 1.97851 9.86411 1.52951 9.69788C1.08052 9.53165 0.693206 9.2319 0.419673 8.83895C0.146141 8.446 -0.000488281 7.97871 -0.000488281 7.49993C-0.000488281 7.02115 0.146141 6.55386 0.419673 6.16091C0.693206 5.76796 1.08052 5.46821 1.52951 5.30198C1.97851 5.13575 2.46764 5.11101 2.93112 5.2311C3.39459 5.35118 3.81017 5.61033 4.12195 5.97368L10.4201 3.04868C10.3484 2.82055 10.312 2.5828 10.3123 2.34368Z"
            fill="currentColor"
          /></svg
        >
      </button>

      <div popover class="share-menu" id="card-share-popover__{item.id}">
        <div class="share-title">Share</div>

        <SocialLinks link={origin + item.link} content={item.title} />

        <div class="share-link">
          <input readonly value={origin + item.link} name="copy-link-field-1" />
          <button
            onclick={KB.mainClasses.Card.copyLink.bind(this, this)}
            type="button"
          >
            Copy Link
          </button>
        </div>

        <button
          class="close-button theme-ghost"
          popovertarget="card-share-popover__{item.id}"
          aria-label="Close"
          type="button"
        ></button>
      </div>
    </div>
  </div>
</div>
